var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "restrict-platform-modal",
      "centered": "",
      "size": "md",
      "hide-header-close": ""
    },
    on: {
      "shown": _vm.getPlatformList
    },
    model: {
      value: _vm.show,
      callback: function callback($$v) {
        _vm.show = $$v;
      },
      expression: "show"
    }
  }, [_c('b-button', {
    staticClass: "btn-container",
    attrs: {
      "variant": "close-btn"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _c('div', {
    staticClass: "platform-title-text text-center"
  }, [_c('h5', [_c('strong', [_vm._v("Restrict Platforms")])])]), _vm.filteredPlatforms.length === 0 ? _c('div', [_c('div', {
    class: {
      'alert alert-danger': _vm.errorMsg
    }
  }, [_vm._v(_vm._s(_vm.errorMsg) + " ")])]) : _c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.updateRestrictPlatform.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "platform-note"
  }, [_c('strong', [_vm._v("Note: ")]), _c('p', [_c('span', {
    staticClass: "checked-icon"
  }, [_vm._v("✔")]), _vm._v(" "), _c('strong', [_vm._v("Checked -")]), _vm._v(" No Access code needed. "), _c('br'), _c('span', {
    staticClass: "unchecked-icon"
  }, [_vm._v("✖")]), _vm._v(" "), _c('strong', [_vm._v(" Unchecked -")]), _vm._v(" Access code needed. ")])]), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-group', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var ariaDescribedby = _ref.ariaDescribedby;
        return [_c('div', {
          staticClass: "restrict-platform-container"
        }, [_c('b-form-checkbox-group', {
          attrs: {
            "id": "checkbox-group-1",
            "options": _vm.filteredPlatforms,
            "aria-describedby": ariaDescribedby
          },
          on: {
            "change": _vm.handleCheckboxChange
          },
          model: {
            value: _vm.selectedPlatforms,
            callback: function callback($$v) {
              _vm.selectedPlatforms = $$v;
            },
            expression: "selectedPlatforms"
          }
        })], 1)];
      }
    }])
  })], 1)]), _c('div', {
    staticClass: "row justify-content-end platform-update text-center"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "univ-btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Update")])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }